import { Link } from 'react-router-dom';
import { usePageChrome } from '@/components/layout/cardShell/pageChrome';

const NotFound = () => {
  // Without this the card header prints the unmatched URL's last segment as a
  // page title — a 404 for /home/hello would be headed "Hello".
  usePageChrome({ title: '', bleed: true });

  return (
    <div className="flex min-h-[70vh] w-full flex-1 items-center justify-center bg-white px-6 py-16">
      <div className="w-full max-w-[560px] text-center">
        <span className="block text-[112px] font-bold leading-none tracking-[-0.04em] text-[#101828] sm:text-[150px]">
          404
        </span>

        <h1 className="mt-7 text-[20px] font-semibold text-[#101828]">
          Oops, this page took a wrong turn.
        </h1>
        <p className="mx-auto mt-1 max-w-[554px] text-[16px] text-[#667085]">
          The page you’re looking for doesn’t exist or may have moved somewhere else.
        </p>

        <div className="mt-5 flex items-center justify-center">
          <Link
            to="/home"
            className="inline-flex h-9 shrink-0 items-center rounded-lg bg-brand px-4 text-[13px] font-semibold text-white transition hover:bg-brand-hover"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
